import { toCurrency } from '@dt/fe-utils'

export function money (amount: number) {
  if (typeof amount !== 'number') return amount
  return toCurrency() + amount.toFixed(2)
}

export function maskBankCardNumber (number: string) {
  const no = number.replace(/X/g, '*').replace(/\s/g, '')
  const result = no.replace(/(.{4})/g, '$1 ')
  return result
}

export function shortCardNumber (number: string) {
  return '**** ' + number.substr(number.length - 4)
}
